// extracted by mini-css-extract-plugin
module.exports = {"categories-card":"category_categories-card__Nz8hZ","first-sub-category":"category_first-sub-category__AmUEb"};